"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const GraphandFieldRelation_1 = __importDefault(require("../lib/fields/GraphandFieldRelation"));
function processPopulate(item, fields, client, populatedPaths) {
    populatedPaths = populatedPaths !== null && populatedPaths !== void 0 ? populatedPaths : Object.keys(fields).filter((key) => fields[key] instanceof GraphandFieldRelation_1.default);
    for (const path of populatedPaths) {
        const field = fields[path];
        const populatedData = (0, lodash_1.get)(item, path);
        if (!field || !populatedData || typeof populatedData !== "object") {
            continue;
        }
        const model = client.getModel(field.ref);
        let value;
        if (field.multiple && Array.isArray(populatedData)) {
            const _items = model.hydrate(populatedData, true);
            value = [..._items].map((i) => i && i._id).filter(Boolean);
        }
        else {
            const _item = model.hydrate(populatedData, true);
            value = _item._id;
        }
        (0, lodash_1.set)(item, path, value);
    }
    return item;
}
exports.default = processPopulate;
